import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-po-ready-to-ship',
  templateUrl: './po-ready-to-ship.component.html',
  styleUrls: ['./po-ready-to-ship.component.scss']
})
export class PoReadyToShipComponent implements OnInit {

  constructor(public dialogref: MatDialogRef<PoReadyToShipComponent>) { }

  ngOnInit() {
  }
  close() {
    this.dialogref.close();
  }

}
